export default __webpack_public_path__ + "static/media/buildIcon.3eaca016.svg";